/* eslint-disable react-hooks/exhaustive-deps */

import { useRef, FC, useLayoutEffect } from 'react';
import { Box } from '@zoopla-eng/zds-components/box';
import triggerTracking from '@blueprint/tracking';
import { PageTitleLong } from '@zoopla-eng/zds-components/headings';

import PreferencesForm from './PreferencesForm';
import { SocialTitleWrapper } from '../AuthModal.styles';
import { PreferencesProps } from './Preferences.types';

const socialRegTitle =
    'Get expert advice, guidance and inspiration straight to your inbox.';

const Preferences: FC<React.PropsWithChildren<PreferencesProps>> = ({
    close,
    actionAfterAuth
}) => {
    const socialHeader = useRef<HTMLHeadingElement>(null);

    useLayoutEffect(() => {
        if (socialHeader?.current) {
            socialHeader?.current.focus();
        }

        triggerTracking({
            event: 'GAEvent',
            eventCategory: 'registration',
            eventAction: 'form shown',
            eventLabel: `${actionAfterAuth?.eventLabel}_step_2`
        });
    }, []);

    return (
        <>
            <Box pb="$M100">
                <SocialTitleWrapper data-testid="social-login-heading-wrapper">
                    <PageTitleLong
                        data-testid="social-login-heading"
                        tabIndex={-1}
                        ref={socialHeader}
                    >
                        {socialRegTitle}
                    </PageTitleLong>
                </SocialTitleWrapper>
            </Box>
            <PreferencesForm close={close} actionAfterAuth={actionAfterAuth} />
        </>
    );
};

export default Preferences;
